import { render, staticRenderFns } from "./SmoothScroll.vue?vue&type=template&id=525e530c&"
import script from "./SmoothScroll.vue?vue&type=script&lang=js&"
export * from "./SmoothScroll.vue?vue&type=script&lang=js&"
import style0 from "./SmoothScroll.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports